import { writable } from 'svelte/store';

export function FormValidator()
{
    const { subscribe, set, update } = writable(0);

    let inputs = [];


    const Update = (index, state) => {
        inputs[index] = state;

        let _state = 1;
        for (const s of inputs)
        {
            if (s !== 1)
            {
                _state = s
                break;
            }
        }
        
        set(_state);
    };
    
    const AddInput = value => {
        inputs.push(value);
        const index = inputs.length - 1;
        Update(index, value);
        return index;
    };
    
    return {
		subscribe,
		increment: () => update(n => n + 1),
		decrement: () => update(n => n - 1),
        reset: () => set(false),
        AddInput,
        Update
	};
}

export function InputValidator(node, validator) {
  
    const validatorIndex = validator.AddInput(0);
    const errorElement = node.nextElementSibling;

    let state = 0; // 0 means we haven't done anything yet

    const setState = s => {
        if (s === -1) // error state
        {
            node.classList.add('error');
            if (errorElement)
                errorElement.classList.add('error');
        }
        else
        {
            node.classList.remove('error');
            if (errorElement)
                errorElement.classList.remove('error');
        }

        validator.Update(validatorIndex, s);
        state = s;
    };
    
    const _validate = value =>
    {
        let _error = false;
        if (node.tagName.toLowerCase() === 'select' || node.tagName.toLowerCase() === 'textarea')
        {
            _error = (value.length === 0);
        }
        else if (node.type === 'email')
        {
            const re = /\S+@\S+/;
            _error = !re.test(String(value).toLowerCase());
        }
        else if (node.type === 'password')
        {
            _error = (value.length < 6);
        }
        else if (node.type === 'tel')
        {
            // make sure there are 10 numbers in it
            if (value)
            {
                const numberPattern = /\d+/g;
                const match = value.match(numberPattern);
                if (match)
                {
                    _error = (match.join('')).length !== 10;
                }
                else
                {
                    _error = true;
                }
            }
            else
            {
                _error = true;
            }
        }
        else
        {
            // just assume the only thing we need is  some value
            if (!value)
                _error = true;
        }

        return _error;
    };

    const onBlur = event => {
        // check the value to see if there is an error
        let isValid = !_validate(node.value);
        setState(isValid ? 1 : -1);
    };

    const onFocus = event => {
        // always remove the error class on focus, even if we haven't resolved the error
        node.classList.remove('error');
    };

    const onChange = event => {
        // only check validation as they are typing if we are in an error state
        let isValid = !_validate(node.value);
        if (state === 0)
        {
            if (isValid)
            {
                setState(1);
            }
        }
        else
        {
            setState(isValid ? 1 : -1);
        }
    };

    const onStupid = event => {
        onChange(event);
    };

    //node.addEventListenr('
    node.addEventListener('blur', onBlur);
    node.addEventListener('focus', onFocus);
    node.addEventListener('input', onChange);
    node.addEventListener('stupid', onStupid);
  
    return {
        destroy() {
            node.removeEventListener('blur', onBlur);
            node.removeEventListener('focus', onFocus);
            node.removeEventListener('input', onChange);
            node.removeEventListener('stupid', onStupid);
        }
    }
}

